import React from 'react'
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import '../components/Styles/contact.css'
import xm1 from '../assets/images/contact.png'
import mem1 from '../assets/images/tmember.png'

const Contact = () => {
  return (
    <div>

      <section className='main_sec__con'>
        <div className='x_row1'>
          <div className='x_col1'>
            <h1 style={{}}>
              Contact <br />
              Us
            </h1>

            <p>
              Welcome to Xceed Office's contact page! We are thrilled to have you here and are ready to assist you with any inquiries, support, or information you might need. Our dedicated team is on standby to provide you with timely and efficient responses, ensuring your experience with us is seamless and positive.
            </p>
          </div>

          <div className='x_col1'>
            <img src={xm1} alt="" />
          </div>
        </div>
      </section>

      <br /><br />

      <section className='con_center'>
        <h2>Get in Touch</h2>
        <br />

        <div className='mb'>
          <label htmlFor="">First Name</label>
          <br />
          <input type="text" />
          <br /><br />

          <label htmlFor="">Last Name</label>
          <br />
          <input type="text" />
          <br /><br />

          <label htmlFor="">Email</label>
          <br />
          <input type="text" />
          <br /><br />

          <label htmlFor="">Phone Number</label>
          <br />
          <input type="text" />
          <br /><br />

          <label htmlFor="">Message</label>
          <br />
          <input type="text" />
          <br /><br />

          <button>Send Message</button>
          <br /><br />
        </div>

        <div className='con_row'>
          <div className='con_col'>
            <h2>Contact Information</h2>
            <p>Say something to start a live chat!</p>
            <br />

            <div className='con_rowico'>
              <div className='can_colico'>
                <i className="ri-phone-fill"></i>
              </div>
              <div className='can_col2ico'>
                <a href="tel:+(281) 346 387 7187">&nbsp;&nbsp;+(346)387 7187</a>
              </div>
            </div>

            <br />

            <div className='con_rowico'>
              <div className='can_colico'>
                <i className="ri-mail-line"></i>
              </div>
              <div className='can_col2ico'>
                <a href="mailto:info@Xceed.com">&nbsp;&nbsp;info@Xceed.com</a>
              </div>
            </div>

            <br />

            <div className='con_rowico'>
              <div className='can_colico'>
                <i className="ri-map-pin-2-fill"></i>
              </div>
              <div className='can_col2ico'>
                <p>&nbsp; 2485 Katy Freeway, Suite 300 Katy TX 77494</p>
              </div>
            </div>
          </div>

          <div className='con_col2'>
            <div className='rowinp'>
              <div className='colinp'>
                <label htmlFor="">First Name</label>
                <br />
                <input type="text" />
              </div>

              <div className='colinp'>
                <label htmlFor="">Last Name</label>
                <br />
                <input type="text" />
              </div>
            </div>

            <br />

            <div className='rowinp'>
              <div className='colinp'>
                <label htmlFor="">Email</label>
                <br />
                <input type="text" />
              </div>

              <div className='colinp'>
                <label htmlFor="">Phone Number</label>
                <br />
                <input type="text" />
              </div>
            </div>

            <br />

            <label htmlFor="">Message</label>
            <br />
            <input type="text" />
            <br /><br />

            <button>Send Message</button>
          </div>
        </div>
      </section>

      <br /><br /><br />
    </div>
  )
}

export default Contact